<template>
  <div class="col-12">
    <div class="row">
      <ol class="breadcrumb" v-bind:class=" { 'col-8 col-md-10': action, 'col-12': !action } ">
        <li class="breadcrumb-item" v-for="(item, index) in list" :key="index"><span class="active" v-if="isLast(index)">{{ showName(item) }}</span>
          <router-link :to="item.path" v-else>{{ showName(item) }}</router-link>
        </li>
      </ol>
      <div v-if="action" class="col-4 col-md-2 text-right p-0 action-btn">
        <router-link :to="action.url" class="btn btn-success"><i v-bind:class="action.icon"></i>&nbsp;&nbsp;{{action.name}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    },
    action: null
  },
  methods: {
    isLast (index) {
      return index === this.list.length - 1
    },
    showName (item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label
      }
      if (item.name) {
        item = item.name
      }
      return item
    }
  }
}
</script>
<style scoped>
  .action-btn {
    padding: 0.75rem 1rem;
    margin-bottom: 1.5rem;
    background-color: #fff;
    border-bottom: 1px solid #c2cfd6;
  }
  .action-btn > .btn {
    margin: 5px 10px;
    font-weight: 400;
  }
</style>




// WEBPACK FOOTER //
// src/components/Breadcrumb.vue